import React, { useState, useEffect } from 'react';
import bigDrp from './images/big2drop.png';

function CountdownTimer({ className = '' }) {
  const [timeLeft, setTimeLeft] = useState({
    days: 300,
    hours: '07',
    minutes: '07'
  });

  useEffect(() => {
    const targetDate = new Date('2026-12-31 23:59:59').getTime();

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance < 0) {
        setTimeLeft({ days: '00', hours: '00', minutes: '00' });
        clearInterval(timer);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

      setTimeLeft({
        days: days.toString(),
        hours: hours < 10 ? '0' + hours : hours.toString(),
        minutes: minutes < 10 ? '0' + minutes : minutes.toString()
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className={`timeManage ${className}`}>
      <h4>
        <span className="cmn days">{timeLeft.days}</span>
        <span> DAYS</span>
      </h4>
      <img src={bigDrp} className="img-fluid" alt="Drop" />

      <h4>
        <span className="cmn hours">{timeLeft.hours}</span>
        <span> HRS.</span>
      </h4>
      <img src={bigDrp} className="img-fluid" alt="Drop" />

      <h4>
        <span className="cmn minutes">{timeLeft.minutes}</span>
        <span> MIN.</span>
      </h4>
    </div>
  );
}

export default CountdownTimer;